module.exports = __webpack_public_path__ + "static/JetBrainsMono-Regular-e1caef645de334fee2f25834b0d03c28.ttf";